import { request } from '.'

export const subscribeEmail = async (email: string) => {
	return await request.post(`/subscribe`, {
		email,
	})
}
